import { EmploymentAvailabilityStatusEnum } from '../../models/user';

export function getUsersByEmploymentAvailabilityMongoQuery(options: {
  // form values can be undefined on init and null when cleared
  startDate: string | null | undefined;
  endDate: string | null | undefined;
  includeUndecided: boolean;
}) {
  const { startDate, endDate, includeUndecided } = options;
  if (!startDate || !endDate) {
    return {};
  }
  const availabilityMatchQuery = {
    employmentAvailabilityDays: {
      $elemMatch: {
        status: 'AVAILABLE',
        $and: [{ date: { $gte: startDate } }, { date: { $lte: endDate } }],
      },
    },
  };
  if (includeUndecided) {
    const completelyUndecidedQuery = {
      employmentAvailabilityDays: {
        $not: {
          $elemMatch: {
            status: {
              $in: [
                EmploymentAvailabilityStatusEnum.WORKING,
                EmploymentAvailabilityStatusEnum.UNAVAILABLE,
              ],
            },
            date: {
              $gte: startDate,
              $lte: endDate,
            },
          },
        },
      },
    };
    return {
      $or: [availabilityMatchQuery, completelyUndecidedQuery],
    };
  }
  return availabilityMatchQuery;
}
